'use strict';

var _id = function _id(id) {
  return "localStore_".concat(id);
};

var _get = function get(id) {
  try {
    return JSON.parse(localStorage.getItem(_id(id)));
  } catch (e) {
    return localStorage.getItem(_id(id));
  }
};

var _set = function set(id, value) {
  if (typeof value === 'undefined' || !id || !value) {
    return false;
  }

  if (typeof value === 'object') {
    localStorage.setItem(_id(id), JSON.stringify(value));
    return true;
  }

  localStorage.setItem(_id(id), value);
  return true;
};

var index = {
  set: function set(id, value) {
    return _set(id, value);
  },
  get: function get(id) {
    return _get(id);
  }
};
module.exports = index;